import { AxiosRequestConfig } from 'axios'
import { ICommunityModel, IPaginationQuery, TAxiosResponsePagination } from 'src/interfaces'
import { axiosHiringApi } from './axios'

export class CommunityApi {
  static readonly _prefix = '/community'

  static communities(
    params: IPaginationQuery & { code?: string } = {},
    config?: AxiosRequestConfig
  ): TAxiosResponsePagination<ICommunityModel> {
    return axiosHiringApi.get(CommunityApi._prefix, {
      ...config,
      params: {
        ...config?.params,
        ...params
      }
    })
  }

  static joinedCommunities(
    params: IPaginationQuery & { code?: string } = {},
    config?: AxiosRequestConfig
  ): TAxiosResponsePagination<ICommunityModel> {
    return axiosHiringApi.get(`${CommunityApi._prefix}/joined`, {
      ...config,
      params: {
        ...config?.params,
        ...params
      }
    })
  }

  static updateJoinedCommunity(
    communityCode: string,
    config?: AxiosRequestConfig
  ) {
    return axiosHiringApi.put<void>(`${CommunityApi._prefix}/joined/${communityCode}`, config)
  }

  static joinCommunity(
    payload: {
      communityCode: string
      joinSource?: string
    },
    config?: AxiosRequestConfig
  ) {
    return axiosHiringApi.post<ICommunityModel>(`${CommunityApi._prefix}/join`, payload, config)
  }

  static leaveCommunity(
    communityCode: string,
    config?: AxiosRequestConfig
  ) {
    return axiosHiringApi.delete<void>(`${CommunityApi._prefix}/${communityCode}`, config)
  }
}
